if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('[data-product-media-previous]');
        this.nextButton = this.querySelector('[data-product-media-next]');
        this.counter = this.querySelector('[data-product-media-counter]');
        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));
        this.previousButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nextButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.querySelector('.product-media-modal__content')?.addEventListener('pointerup', (event) => {
          event.stopPropagation();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaItems = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        mediaItems.forEach((element) => element.classList.toggle('active', element === activeMedia));
        this.activeMediaIndex = Math.max(0, mediaItems.indexOf(activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.updateControls(mediaItems.length);

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMedia(direction) {
        const mediaItems = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        if (mediaItems.length < 2) return;
        this.activeMediaIndex = (this.activeMediaIndex + direction + mediaItems.length) % mediaItems.length;
        const activeMedia = mediaItems[this.activeMediaIndex];
        mediaItems.forEach((element) => element.classList.toggle('active', element === activeMedia));
        this.updateControls(mediaItems.length);
      }

      updateControls(total) {
        const hasMultipleMedia = total > 1;
        if (this.previousButton) this.previousButton.hidden = !hasMultipleMedia;
        if (this.nextButton) this.nextButton.hidden = !hasMultipleMedia;
        if (this.counter) {
          this.counter.hidden = !hasMultipleMedia;
          this.counter.textContent = hasMultipleMedia ? `${this.activeMediaIndex + 1} / ${total}` : '';
        }
      }
    }
  );
}
